import {
  SIDEBAR_DRAWER_SIZE
} from "./chunk-65W2CFPO.mjs";
import {
  useSmallScreen
} from "./chunk-ALXBK6NV.mjs";

// src/internal/hooks/use-sidebar.ts
import * as React from "react";
import { useLocation } from "react-router-dom";
import { useBoolean, useId } from "@clara/hooks";
import { callAllHandlers } from "@clara/utils";
function useSidebar(props = {}) {
  const sm = useSmallScreen();
  const [isOpenBool, setOpen] = useBoolean();
  const [isCollapsed, setCollapsed] = useBoolean();
  const isOpen = isOpenBool || !sm;
  const location = useLocation();
  const id = useId(props == null ? void 0 : props.id);
  React.useEffect(() => {
    if (!sm) {
      setOpen.toggle(sm);
    } else {
      setOpen.off();
    }
  }, [sm, location]);
  const getButtonProps = React.useCallback(
    (props2 = {}) => ({
      ...props2,
      "aria-expanded": "true",
      "aria-controls": id,
      onClick: callAllHandlers(props2.onClick, () => setOpen.toggle())
    }),
    [id, setOpen]
  );
  const getCollapseButtonProps = React.useCallback(
    (props2 = {}) => ({
      ...props2,
      onClick: callAllHandlers(props2.onClick, () => setCollapsed.toggle())
    }),
    [setCollapsed]
  );
  const getDrawerProps = React.useCallback(
    (props2, ref = null) => ({
      ref,
      ...props2,
      onClose: setOpen.off,
      isOpen,
      variant: sm ? "temporary" : "permanent",
      hideBackdrop: !sm,
      container: (props2 == null ? void 0 : props2.window) !== void 0 ? () => props2 == null ? void 0 : props2.window().document.body : void 0
    }),
    [sm, isOpen, setOpen]
  );
  const offset = React.useMemo(() => {
    const value = sm === true || isOpen === false ? "0" : isCollapsed ? SIDEBAR_DRAWER_SIZE.collapsed : SIDEBAR_DRAWER_SIZE.lg;
    return +value.replace(/\D/g, "");
  }, [sm, isCollapsed, isOpen]);
  return {
    sm,
    isOpen,
    isCollapsed,
    offset,
    onClose: setOpen.off,
    onToggle: setOpen.toggle,
    onCollapseToggle: setCollapsed.toggle,
    getButtonProps,
    getDrawerProps,
    getCollapseButtonProps
  };
}

export {
  useSidebar
};
